import React, { useEffect } from "react";
import API from "../utils/api";  // ✅ Use API utility instead of axios

export default function LocationUpdater({ token, intervalMinutes = 5 }) {
  useEffect(() => {
    if (!token) return;

    const updateLocation = () => {
      if (!navigator.geolocation) {
        console.warn("Geolocation not supported by browser.");
        return;
      }

      navigator.geolocation.getCurrentPosition(
        async (pos) => {
          const { latitude, longitude } = pos.coords;
          try {
            // ✅ Use API utility which handles base URL and token automatically
            await API.post(
              "rep-activity/",  // ✅ No leading slash - API utility adds baseURL
              { latitude, longitude }
              // ✅ No need for headers - API utility adds Authorization header automatically
            );
          } catch (err) {
            console.error("Error updating location:", err.message);
          }
        },
        (err) => {
          console.warn("Location access denied or unavailable:", err.message);
        },
        { enableHighAccuracy: true, timeout: 10000 }
      );
    };

    // iOS/PWA reliability: request location from first user gesture rather than on mount.
    let hasRequestedFromGesture = false;
    const requestFromGesture = () => {
      if (hasRequestedFromGesture) return;
      hasRequestedFromGesture = true;
      updateLocation();
      window.removeEventListener("pointerdown", requestFromGesture);
      window.removeEventListener("keydown", requestFromGesture);
    };
    window.addEventListener("pointerdown", requestFromGesture, { passive: true });
    window.addEventListener("keydown", requestFromGesture);

    // Repeat every X minutes
    const interval = setInterval(updateLocation, intervalMinutes * 60 * 1000);
    return () => {
      clearInterval(interval);
      window.removeEventListener("pointerdown", requestFromGesture);
      window.removeEventListener("keydown", requestFromGesture);
    };
  }, [token, intervalMinutes]);

  return null; // invisible helper component
}
